<template>
	<attr-detail :is-edit='true'>
	</attr-detail>
</template>

<script>
	import AttrDetail from './attrDetail.vue'
	export default {
		name: 'updateProductAttr',
		components: {
			AttrDetail
		}
	}
</script>

<style scoped>

</style>
